import SpriteSymbol from "../../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lighthttpd2",
  "use": "lighthttpd2-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"lighthttpd2\"><path d=\"M16.97 2L1.03 6.92l3.5 3.76L16.8 2.11 4.82 10.93l.97 2.81.36-1.81L16.97 2 6.5 12.13l-.01.03 6.8 3.84 3.68-14zm-4.03 10.71v.71h-2.43v-.8c0-.7.57-1.27 1.27-1.27h.2c.18 0 .32-.14.32-.32s-.14-.32-.32-.32h-.61c-.08 0-.14.06-.14.14v.07h-.71v-.07c0-.47.39-.86.86-.86h.61a1.04 1.04 0 110 2.08h-.2c-.31 0-.55.25-.55.55v.09h1.7zM5.8 13.73v.01l1.01-.92-.47-.32-.54 1.23z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol